export class DeviceParamDauV5 {

    public screwTerminalBlock: string;

}
